import * as React from "react";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";

interface Props {
  title: string;
  subtitle: string;
  image: string;
}

export default function PaperImage(props: Props) {
  return (
    <React.Fragment>
      <Paper
        elevation={0}
        sx={{
          position: "relative",
          backgroundColor: "grey.800",
          color: "#fff",
          mb: 4,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
          backgroundImage: `url(${props.image})`,
        }}
      >
        <Box
          sx={{
            position: "absolute",
            top: 0,
            bottom: 0,
            right: 0,
            left: 0,
            backgroundColor: "rgba(0,0,0,.3)",
          }}
        />
        <Grid container>
          <Grid item xs={12}>
            <Box
              sx={{
                position: "relative",
                p: { xs: 3, md: 6 },
                pr: { md: 0 },
              }}
            >
              <Typography component="h1" variant="h3" color="inherit" gutterBottom>
                {props.title}
              </Typography>
              <Typography variant="h5" color="inherit" paragraph>
                {props.subtitle}
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Paper>
    </React.Fragment>
  );
}
